var styles = {};
export default styles;



//////////////////
// WEBPACK FOOTER
// ./src/components/RadioGroup/styles.ts
// module id = 1477
// module chunks = 0